import { useEffect } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Featured from "./components/Featured";
import Ranking from "./components/Ranking";
import Categories from "./components/Categories";
import NewReleases from "./components/NewReleases";
import Articles from "./components/Articles";
import Faq from "./components/Faq";
import Testimonials from "./components/Testimonials";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const q = params.get("q");
    if (q) {
      document.getElementById("featured")?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Featured />
        <Ranking />
        <Categories />
        <NewReleases />
        <Articles />
        <Faq />
        <Testimonials />
        <Newsletter />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}